/* ==================================================
   FORM（お問い合わせボタン）
   試着・非試着による表示切替 ＋ 値引き継ぎ（custom-select対応・h1フォールバック対応）
================================================== */

document.addEventListener('DOMContentLoaded', function () {

    const contactButtonSelector = '.custom-contact-button';
    const gpoContainerSelector = '.gpo-container';
    const addToCartSelector = '.add-to-cart.gpo-clone-atc-button';

    /* ------------------------------
       値取得ヘルパー関数
    ------------------------------ */
    function getRentalValue() {
        const checked = document.querySelector('fieldset[data-option="レンタル料金"] .js-option:checked');
        if (checked) return checked.value.trim();

        const active = document.querySelector('.option-selector[data-option="レンタル料金"] .custom-select__btn .text-start');
        if (active) return active.textContent.trim();

        return '';
    }

    function getSizeValue() {
        const checked = document.querySelector('fieldset[data-option="サイズ"] .js-option:checked');
        if (checked) return checked.value.trim();

        const active = document.querySelector('.option-selector[data-option="サイズ"] .custom-select__btn .text-start');
        if (active) return active.textContent.trim();

        return '';
    }

    /* ------------------------------
       表示切替処理
       （レンタル料金セレクトが無い場合はスキップ）
    ------------------------------ */
    function updateDisplay() {
        const hasRentalField = document.querySelector('.option-selector[data-option="レンタル料金"]');
        if (!hasRentalField) {
            // レンタル料金が無い場合は非制御
            console.log("ℹ️ レンタル料金フィールドなし。display制御スキップ。");
            return;
        }

        const rentalValue = getRentalValue();
        const isTryOn = rentalValue === '試着';

        const contactButton = document.querySelector(contactButtonSelector);
        const gpoContainer = document.querySelector(gpoContainerSelector);
        const addToCartBtn = document.querySelector(addToCartSelector);

        if (contactButton) contactButton.style.display = isTryOn ? 'none' : 'block';
        if (gpoContainer) gpoContainer.style.display = isTryOn ? 'block' : 'none';
        if (addToCartBtn) addToCartBtn.style.display = isTryOn ? 'block' : 'none';

        console.log(`🧩 レンタル料金: ${rentalValue || '(なし)'} → ${isTryOn ? '試着モード' : '通常モード'}`);
    }

    /* ------------------------------
       フォームへの値引き継ぎ
       （h1フォールバック対応）
    ------------------------------ */
    function fillFormValues() {
        const hasRentalField = document.querySelector('.option-selector[data-option="レンタル料金"]');
        const hasSizeField = document.querySelector('.option-selector[data-option="サイズ"]');

        const rentalValue = hasRentalField ? getRentalValue() : '';
        const sizeValue = hasSizeField ? getSizeValue() : '';
        const title =
            document.querySelector('.product-title')?.textContent.trim() ||
            document.querySelector('h1')?.textContent.trim() ||
            '';

        const rentalInput = document.querySelector('[name="text-2"]');
        const sizeInput = document.querySelector('[name="text-4"]');
        const titleInput = document.querySelector('[name="text-5"]');

        // 値の反映（存在する場合のみ）
        if (rentalInput && rentalValue) rentalInput.value = rentalValue;
        if (sizeInput && sizeValue) sizeInput.value = sizeValue;
        if (titleInput && title) titleInput.value = title;

        console.log("✅ 自動入力:", { rentalValue, sizeValue, title });
    }

    /* ------------------------------
       自動入力発火（試着以外時）
    ------------------------------ */
    function setupFormAutofill() {
        const buttons = document.querySelectorAll(`${contactButtonSelector}, ${gpoContainerSelector} button, ${addToCartSelector}`);
        buttons.forEach(btn => {
            btn.addEventListener('click', () => {
                const rentalFieldExists = document.querySelector('.option-selector[data-option="レンタル料金"]');
                const rentalValue = rentalFieldExists ? getRentalValue() : '';
                // 試着モード時のみスキップ
                if (rentalFieldExists && rentalValue === '試着') return;

                setTimeout(() => fillFormValues(), 800);
            });
        });
    }

    /* ------------------------------
       イベント監視
    ------------------------------ */
    function attachEventListeners() {
        const radios = document.querySelectorAll('.option-selector[data-option="レンタル料金"] .js-option[type="radio"]');
        radios.forEach(radio => radio.addEventListener('change', updateDisplay));

        document.body.addEventListener('click', (e) => {
            const option = e.target.closest('.option-selector[data-option="レンタル料金"] .custom-select__option, .option-selector[data-option="サイズ"] .custom-select__option');
            if (option) {
                setTimeout(() => {
                    updateDisplay();
                    fillFormValues();
                }, 150);
            }
        });
    }

    /* ------------------------------
       初期化
    ------------------------------ */
    function init() {
        attachEventListeners();
        setupFormAutofill();

        // 初期描画後に反映（遅延してDOM安定化後）
        setTimeout(() => {
            updateDisplay();
            fillFormValues();
        }, 700);
    }

    /* ------------------------------
       動的描画対応
    ------------------------------ */
    const observer = new MutationObserver(() => {
        const ready = document.querySelector('.product-title, h1');
        if (ready) {
            init();
            observer.disconnect();
        }
    });
    observer.observe(document.body, { childList: true, subtree: true });

});
